import classNames from 'classnames'
import { forwardRef, memo } from 'react'
import { Icon } from '../Icon'
import * as styles from './styles'
import { type PillProps } from './types'

export { selectors as pillSelectors } from './styles'

export const Pill = memo(
  forwardRef<HTMLDivElement, PillProps>(
    (
      {
        ariaLabel,
        className,
        color,
        glyph,
        size,
        solid = false,
        text,
        truncateText = false,
      },
      ref
    ) => (
      <div
        ref={ref}
        aria-label={ariaLabel}
        className={classNames(
          styles.selectors.root,
          className,
          `color-${color}`,
          `size-${size}`,
          {
            [styles.stateVariables.hasIcon]: !!glyph,
            [styles.stateVariables.solid]: solid,
            [styles.stateVariables.truncateText]: truncateText,
          }
        )}
        css={styles.root}
      >
        {glyph && (
          <Icon ariaHidden={true} glyph={glyph} size={styles.iconSize[size]} />
        )}
        <span className={styles.selectors.text}>{text}</span>
      </div>
    )
  )
)
Pill.displayName = 'Lapidary: Pill'
